
import { defineComponent, onMounted, ref } from "vue";
import WidgetBlog from "@/components/widgets/mixed/WidgetBlog.vue";
import WidgetPatientStatus from "@/components/widgets/mixed/WidgetPatientStatus.vue";
import WidgetCaseManager from "@/components/widgets/mixed/WidgetCaseManager.vue";
import Wizard from "@/components/wizard/steps/Wizard.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import useLocale from "@/core/common/useLocale";

export default defineComponent({
  name: "dashboard",
  components: {
    WidgetPatientStatus,
    WidgetCaseManager,
    WidgetBlog,
    Wizard,
  },
  inject: ["ismobile"],
  setup() {
    const refWizard = ref();
    const refWidgetCaseManager = ref();
    const refWidgetPatientStatus = ref();
    const { currentLocale } = useLocale();

    onMounted(async () => {
      await store.dispatch(Actions.GET_PATIENT_VALUES, {
        keyp: "widget_result",
      });
      await store.dispatch(Actions.GET_PATIENT_PROCESSES, {});
      refWizard.value.getPatientValues();
      refWidgetCaseManager.value.getInformation();
      refWidgetPatientStatus.value.getPatientValues();
    });

    const updateComponents = async () => {
      await store.dispatch(Actions.GET_PATIENT_VALUES, {
        keyp: "widget_result",
      });
      await store.dispatch(Actions.GET_PATIENT_PROCESSES, {});
      refWizard.value.getPatientValues();
      refWidgetCaseManager.value.getInformation();
      refWidgetPatientStatus.value.getPatientValues();
    };

    onMounted(() => {
      setCurrentPageTitle("Dashboard");

      //Remove localstorage keys
      localStorage.removeItem("step");
      localStorage.removeItem("cancer_type");
      localStorage.removeItem("birthdate");
      localStorage.removeItem("fullname");
      localStorage.removeItem("patient_s_phone");
      localStorage.removeItem("country_code");
    });

    return {
      refWizard,
      refWidgetCaseManager,
      refWidgetPatientStatus,
      updateComponents,
      ...useLocale(),
    };
  },
});
